import React from "react";
import { StyleSheet, Text, TextStyle, View } from "react-native";
import { ADMIN_TOKENS } from "../../../styles/adminTokens";
import InfoTooltipButton from "./InfoTooltipButton";

type FieldLabelProps = {
  text: string;
  width?: number;
  tooltipText?: string;
  tooltipAccessibilityLabel?: string;
  labelStyle?: TextStyle;
  tooltipTrackingEventName?: string;
  tooltipTrackingProperties?: Record<string, unknown>;
};

const FieldLabel: React.FC<FieldLabelProps> = ({
  text,
  width = 120,
  tooltipText,
  tooltipAccessibilityLabel,
  labelStyle,
  tooltipTrackingEventName,
  tooltipTrackingProperties,
}) => {
  if (!text) return null;

  return (
    <View style={[styles.container, { width }]}>
      <Text style={[styles.label, labelStyle]}>{text}</Text>
      {tooltipText ? (
        <InfoTooltipButton
          text={tooltipText}
          accessibilityLabel={
            tooltipAccessibilityLabel ?? `Show help for ${text}`
          }
          trackingEventName={tooltipTrackingEventName}
          trackingProperties={{
            "Tooltip Name": text,
            ...tooltipTrackingProperties,
          }}
        />
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    gap: ADMIN_TOKENS.spacing.xs,
  },
  label: {
    flex: 1,
    fontFamily: ADMIN_TOKENS.font.medium,
    fontSize: ADMIN_TOKENS.fontSize.md,
    lineHeight: ADMIN_TOKENS.lineHeight.md,
    color: ADMIN_TOKENS.color.textPrimary,
  },
});

export default FieldLabel;
